import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { authSelector, userSelector } from '../../../../selectors';
import { useGetIssuerShortname } from '../../../../hooks/use-get-issuer-shortname';
import { useGetRouteToIssuerPage } from '../../../../app/get-route-to-page';
import { Page } from '../../../../app/page-url-path';
import { useGetPageConditionRequirementResults } from '../../../../app/pages-requiring-condition';

const useUserContextMenu = () => {
  const { isAuthenticated } = useSelector(authSelector);
  const { name } = useSelector(userSelector);
  const issuerShortName = useGetIssuerShortname() ?? '';

  const history = useHistory();
  const dispatch = useDispatch();

  const loginUrl = useGetRouteToIssuerPage(Page.LOGIN_PAGE);
  const pageAvailability = useGetPageConditionRequirementResults();

  const accountPageUrl = useGetRouteToIssuerPage(Page.ACCOUNT_PAGE);

  const showLoginButton = !isAuthenticated && pageAvailability[Page.LOGIN_PAGE];
  const showLogoutButton = isAuthenticated;

  const displayedUserName = `${name.first} ${name.last}`;
  const avatarUserName = `${name.first[0]}${name.last[0]}`.toUpperCase();

  return {
    dispatch,
    history,
    issuerShortName,
    showLoginButton,
    loginUrl,
    showLogoutButton,
    isAccountPageAvailable: pageAvailability[Page.ACCOUNT_PAGE],
    accountPageUrl,
    avatarUserName,
    displayedUserName,
  };
};

export default useUserContextMenu;
